import { gql } from '@apollo/client';
import type { Report2VisibilitySectionFragment } from '../../../../../generated/types';
import { useReportDynamicData } from '../../../hooks';
import {
  SectionDescription,
  SectionGroup,
  SectionHeader,
  SectionHeaderGrid,
  SectionInsights,
} from '../../common';
import VisibilityHighlights from './VisibilityHighlights';
import VisibilityMentionsOverTime from './VisibilityMentionsOverTime';
import VisibilityOverview from './VisibilityOverview';
import VisibilityReachOverTime from './VisibilityReachOverTime';

export const REPORT2_VISIBILITY_SECTION_FRAGMENT = gql`
  fragment Report2VisibilitySection on ReportVisibilitySection {
    id
    title
    state
    subSections {
      ...Report2VisibilityOverview
      ...Report2SectionInsights
      ...Report2VisibilityMentionsOverTime
      ...Report2VisibilityReachOverTime
      ...Report2VisibilityHighlights
    }
  }
`;

interface Props {
  section: Report2VisibilitySectionFragment;
}
export const VisibilitySection = ({ section }: Props) => {
  const { brandColor } = useReportDynamicData();

  return (
    <SectionGroup id={section.id}>
      <SectionHeaderGrid>
        <SectionHeader
          as="h2"
          variant="reportDisplayLarge"
          mobileVariant="reportDisplaySmall"
          section={section}
          color={brandColor}
        />
        <SectionDescription
          as="p"
          variant="reportLabelMedium"
          textAlign="right"
          section={section}
        />
      </SectionHeaderGrid>
      {section.subSections.map(subSection => {
        switch (subSection.__typename) {
          case 'ReportVisibilityOverview':
            return <VisibilityOverview key={subSection.id} section={subSection} />;
          case 'ReportSectionInsights':
            return <SectionInsights key={subSection.id} section={subSection} />;
          case 'ReportVisibilityMentionsOverTime':
            return <VisibilityMentionsOverTime key={subSection.id} section={subSection} />;
          case 'ReportVisibilityReachOverTime':
            return <VisibilityReachOverTime key={subSection.id} section={subSection} />;
          case 'ReportVisibilityHighlights':
            return <VisibilityHighlights key={subSection.id} section={subSection} />;
          default:
            return null;
        }
      })}
    </SectionGroup>
  );
};
